export default __webpack_public_path__ + "static/media/map-pin.0eedd38e.svg";